import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  background-color: #${props => props.theme.carvana.lightBlue};
  padding-top: ${props => (props.hideMobilePadding ? '0' : '3rem')};
  flex-direction: column;
  min-height: 94vh;

  @media (min-width: ${props => props.theme.breakpoints.sm}px) {
    padding-top: 0;
    min-height: 91vh;
    flex-direction: ${props => !props.isLoading && 'row'};
  }

  @media (orientation: landscape) and (max-width: ${props =>
      props.theme.breakpoints.sm}px) {
    min-height: 86vh;
  }

  @media (min-height: 1200px) {
    min-height: 92.75vh;
  }

  @media (min-height: 1400px) {
    min-height: 93vh;
  }

  @media (min-height: 1600px) {
    min-height: 94vh;
  }

  @media (min-height: 1900px) {
    min-height: 95vh;
  }
`;

export const MainSection = styled.div`
  flex-grow: 1;
  height: 100%;
  position: relative;
  padding-bottom: 84px;

  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    padding-bottom: 124px;
  }
`;

const HideWrapper = css`
  display: none;
`;

const NoPadding = css`
  padding: 0px 0px !important;
`;

export const MainSectionWrapper = styled.div`
  ${props => props.removePadding && NoPadding}
  padding: 56px 24px 5px;

  @media (min-width: ${props => props.theme.breakpoints.sm}px) {
    padding: ${props =>
      props.isInPurchaseHeaderBucket ? '80px 4% 75px' : '120px 4% 75px'};
  }

  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    padding-left: 10%;
    padding-right: 10%;
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    padding-left: 15%;
    padding-right: 15%;
  }

  ${props => props.hide && HideWrapper}
`;
